import React, { useEffect, useState } from "react";
import theme from "../../Styles/theme";
import { Alert } from "../Error/Alert";
import { ModalDivX } from "../ModalDivX";
import Modal from "react-modal";
import {
  IFuncionarioCartorio,
  useFuncionarioCartorio,
} from "../../Hooks/funcionarioCartorio";
import {
  AtivarDiv,
  AtivoSpan,
  Container,
  HandleButton,
  HandleInput,
  Label,
} from "./styles";
import { validateEmail } from "../../Services/validaEmail";
import { limpa_cpf_cnpj } from "../../Services/limpa_cpf_cnpj";
import { validateCPF } from "../../Services/validateCPF";
import { limpaMaskCelular } from "../../Services/limpaMaskCelular";
import { validaCelular } from "../../Services/validaCelular";
import { PerfilInput } from "../PerfilInput";
import { DarkButton } from "../DarkButton";
import api from "../../Services/api";
import { ModalLoader } from "../ModalLoader";
import { useCartorio } from "../../Hooks/cartorio";
import Switch from "react-switch";
import {
  IFuncionarioPrefeitura,
  useFuncionarioPrefeitura,
} from "../../Hooks/funcionarioPrefeitura";
import { usePrefeitura } from "../../Hooks/usePrefeitura";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  item: IFuncionarioCartorio | IFuncionarioPrefeitura;
  open: boolean;
  onClose(): void;
}
export function EditFuncionarioModal({ open, onClose, item }: Props) {
  const [loading, setLoading] = useState(false);
  const [NOME, setNome] = useState("");
  const [CPF, setCPF] = useState("");
  const [EMAIL, setEMAIL] = useState("");
  const [WHATS, setWHATS] = useState("");
  const [FONE, setFONE] = useState("");
  const [SENHA, setSENHA] = useState("");
  const [AVALIAR, setAVALIAR] = useState("S" as "S" | "N");
  const [error, setError] = useState({ message: "", title: "" } as {
    message: string;
    title: string;
  });
  const [ativo, setAtivo] = useState(false);
  const { cartorio, cartorioIsLogged } = useCartorio();
  const { prefeitura, prefeituraIsLogged } = usePrefeitura();
  const { atualiza, funcionariosCartorio } = useFuncionarioCartorio();
  const {
    atualizaFuncionarioPrefeitura,
    funcionariosPrefeitura,
  } = useFuncionarioPrefeitura();
  useEffect(() => {
    setNome(item.NOME);
    setCPF(item.CPF);
    setEMAIL(item.EMAIL);
    setWHATS(item.WHATS);
    setFONE(item.FONE);
    setAtivo(item.ATIVO.trim() == "A" ? true : false);
    if(item.AVALIAR){
      setAVALIAR(item.AVALIAR)
    }

  }, [open]);

  function validaForm() {
    if (!validateEmail(EMAIL)) {
      setError({
        message: `O endereço de email digitado não é válido!`,
        title: "Email Inválido!",
      });
      return false;
    }
    if (NOME.trim().length == 0) {
      setError({
        message: `Não é possível adicionar um funcionário com nome vázio!`,
        title: "Nome Inválido!",
      });
      return false;
    }

    if (!validateCPF(limpa_cpf_cnpj(CPF))) {
      setError({
        message: `O CPF digitado não é válido!`,
        title: "CPF Inválido!",
      });
      return false;
    }

    if (Number(limpaMaskCelular(WHATS)) > 0) {
      if (!validaCelular(limpaMaskCelular(WHATS))) {
        setError({
          message: `O número de celular não é válido!`,
          title: "Celular Inválido!",
        });
        return false;
      }
    }

    if (Number(limpaMaskCelular(FONE)) > 0) {
      if (!validaCelular(limpaMaskCelular(FONE))) {
        setError({
          message: `O número de telefone não é válido!`,
          title: "Telefone Inválido!",
        });
        return false;
      }
    }

    return true;
  }

  async function post() {
    if (validaForm())
      try {
        setLoading(true);

        if (cartorioIsLogged) {
          const funcionarios = await api.get<IFuncionarioCartorio[]>(
            `/funcionario-cartorio/por-cpf/${limpa_cpf_cnpj(CPF)}`
          );

          if (funcionarios.data.length > 0) {
            for (let index = 0; index < funcionarios.data.length; index++) {
              const element = funcionarios.data[index];
              if (element.CARTORIO_ID == cartorio.ID && element.ID != item.ID) {
                setError({
                  title: "Não foi possível atualizar um novo usuario!",
                  message: "Já existe um funcionário com este CPF!",
                });
                return;
              }
            }
          }

          const { data } = await api.put<IFuncionarioCartorio>(
            `/funcionario-cartorio/update`,
            {
              ID: item.ID,
              NOME,
              CPF: limpa_cpf_cnpj(CPF),
              EMAIL,
              WHATS: limpaMaskCelular(WHATS),
              SENHA: SENHA.length > 0 ? SENHA : item.SENHA,
              FONE: limpaMaskCelular(FONE),
              ATIVO: ativo ? "A" : "I",
              CARTORIO_ID: cartorio.ID,
            }
          );

          console.log(funcionariosCartorio);
          atualiza(data);
          console.log(funcionariosCartorio);
        } else if (prefeituraIsLogged) {
          const funcionarios = await api.get<IFuncionarioPrefeitura[]>(
            `/funcionario-cartorio/por-cpf/${limpa_cpf_cnpj(CPF)}`
          );

          if (funcionarios.data.length > 0) {
            for (let index = 0; index < funcionarios.data.length; index++) {
              const element = funcionarios.data[index];
              if (
                element.PREFEITURA_ID == prefeitura.ID &&
                element.ID != item.ID
              ) {
                setError({
                  title: "Não foi possível atualizar um novo usuario!",
                  message: "Já existe um funcionário com este CPF!",
                });
                return;
              }
            }
          }

          const { data } = await api.put<IFuncionarioPrefeitura>(
            `/funcionario-prefeitura/update`,
            {
              ID: item.ID,
              NOME,
              CPF: limpa_cpf_cnpj(CPF),
              EMAIL,
              WHATS: limpaMaskCelular(WHATS),
              SENHA: SENHA.length > 0 ? SENHA : item.SENHA,
              FONE: limpaMaskCelular(FONE),
              ATIVO: ativo ? "A" : "I",
              PREFEITURA_ID: prefeitura.ID,
              AVALIAR
            }
          );

          atualizaFuncionarioPrefeitura(data);
        }

        onClose();
      } catch (error) {
        setError({
          title: "Não foi possível atualizar o funcionário!",
          message: `
          Não foi possível atualizar o funcionário ${item.NOME}, tente novamente mais tarde!
          `,
        });
      } finally {
        setLoading(false);
      }
  }
  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <Container>
        <ModalDivX execute={onClose} />
        <HandleInput>
          <PerfilInput
            execute={(str) => {
              setNome(str);
            }}
            value={NOME}
            title={"NOME"}
            ativo={true}
            disabled={false}
          />
          <PerfilInput
            execute={(str) => {
              setEMAIL(str);
            }}
            value={EMAIL}
            title={"EMAIL"}
            ativo={true}
            disabled={false}
          />
        </HandleInput>

        <HandleInput>
          <PerfilInput
            execute={(str) => {
              setFONE(str);
            }}
            value={FONE}
            title={"FONE"}
            ativo={true}
            disabled={false}
          />
          <PerfilInput
            execute={(str) => {
              setWHATS(str);
            }}
            value={WHATS}
            title={"CELULAR"}
            ativo={true}
            disabled={false}
          />
        </HandleInput>

        <HandleInput>
          <PerfilInput
            execute={(str) => {
              setCPF(str);
            }}
            value={CPF}
            title={"CPF"}
            ativo={true}
            disabled={false}
          />
          <PerfilInput
            execute={(str) => {
              setSENHA(str);
            }}
            value={SENHA}
            title={"SENHA"}
            ativo={true}
            disabled={false}
          />
        </HandleInput>
            <AtivarDiv>
            {cartorioIsLogged ? (
          <></>
        ) : (
          <Label>
            <AtivoSpan>
              {AVALIAR ? "Avaliador" : "Avaliador"}
            </AtivoSpan>
            <Switch
              onChange={() => {
                setAVALIAR((prev) => (prev == "S" ? "N" : "S"));
              }}
              checked={AVALIAR == "S"}
              color={theme.colors.primary}
              offColor={theme.colors.darkGrey}
              onColor={theme.colors.primary}
            />
          </Label>
        )}
            </AtivarDiv>

        <AtivarDiv>
          <Label>
            <AtivoSpan>
              {ativo ? "Desativar funcionário" : "Ativar funcionário"}
            </AtivoSpan>
            <Switch
              onChange={() => {
                setAtivo(!ativo);
              }}
              checked={ativo}
              color={theme.colors.primary}
              offColor={theme.colors.darkGrey}
              onColor={theme.colors.primary}
            />
          </Label>
        </AtivarDiv>
        <HandleButton>
          <DarkButton title="CONFIRMAR" execute={post} />
        </HandleButton>
        <ModalLoader loading={loading} />
        <Alert
          title={error.title}
          message={error.message}
          open={error.message.length > 0}
          onClose={() => {
            setError({ title: "", message: "" });
          }}
        />
      </Container>
    </Modal>
  );
}
